const EMOJI_CATEGORIES = [
  { label: 'Smileys', ranges: [[0x1f600, 0x1f64f], [0x1f910, 0x1f92f], [0x1f970, 0x1f97a], [0x1f9d0, 0x1f9e6], [0x1fae0, 0x1fae8]] },
  { label: 'People', ranges: [[0x1f385, 0x1f3ff], [0x1f466, 0x1f487], [0x1f574, 0x1f57a], [0x1f590, 0x1f596], [0x1f645, 0x1f64f], [0x1f6b6, 0x1f6b6], [0x1f9b5, 0x1f9b6], [0x1f9bb, 0x1f9dd], [0x1faf0, 0x1faf8]] },
  { label: 'Animals', ranges: [[0x1f300, 0x1f320], [0x1f330, 0x1f335], [0x1f400, 0x1f43e], [0x1f980, 0x1f9af], [0x1f990, 0x1f9a2], [0x1f9a5, 0x1f9aa]] },
  { label: 'Food', ranges: [[0x1f32d, 0x1f37f], [0x1f950, 0x1f96f], [0x1f9c0, 0x1f9c2], [0x1f9c4, 0x1f9cb]] },
  { label: 'Travel', ranges: [[0x1f680, 0x1f6ff], [0x1f3e0, 0x1f3f0], [0x1f5fb, 0x1f5ff]] },
  { label: 'Activities', ranges: [[0x1f3a0, 0x1f3ff], [0x1f947, 0x1f94f], [0x1f9e7, 0x1f9ff]] },
  { label: 'Objects', ranges: [[0x1f4a0, 0x1f4ff], [0x1f500, 0x1f5fa], [0x1f9cd, 0x1f9cf], [0x1fa70, 0x1faff]] },
  { label: 'Symbols', ranges: [[0x2300, 0x23ff], [0x2600, 0x27bf]] },
  { label: 'Flags', ranges: [[0x1f1e6, 0x1f1ff]] },
];

const createEmojiGroups = () => {
  const isEmoji = /\p{Emoji_Presentation}/u;
  const isPictographic = /\p{Extended_Pictographic}/u;
  const isModifierBase = /\p{Emoji_Modifier_Base}/u;
  const tones = ['🏻', '🏼', '🏽', '🏾', '🏿'];
  const groups = {};

  EMOJI_CATEGORIES.forEach(({ label, ranges }) => {
    const emoji = new Set();
    ranges.forEach(([start, end]) => {
      for (let point = start; point <= end; point += 1) {
        const character = String.fromCodePoint(point);
        if (isEmoji.test(character)) {
          emoji.add(character);
          if (isModifierBase.test(character)) tones.forEach(tone => emoji.add(character + tone));
        } else if (isPictographic.test(character)) {
          emoji.add(`${character}\uFE0F`);
        }
      }
    });
    groups[label] = [...emoji];
  });

  groups.Smileys.push(
    '👨‍👩‍👧‍👦', '👨‍👩‍👦', '👩‍👩‍👧', '👨‍👨‍👦', '🧑‍🤝‍🧑',
    '❤️‍🔥', '❤️‍🩹', '🏳️‍🌈', '🏳️‍⚧️'
  );
  groups.Flags.push(...'🇺🇸 🇬🇧 🇮🇳 🇨🇦 🇦🇺 🇳🇿 🇩🇪 🇫🇷 🇮🇹 🇪🇸 🇧🇷 🇯🇵 🇰🇷 🇨🇳 🇸🇬 🇦🇪 🇸🇦 🇿🇦 🇲🇽 🇵🇰 🇧🇩 🇱🇰 🇳🇵 🇳🇬 🇪🇬 🇹🇷 🇺🇦 🇷🇺 🇺🇳'.split(' '));
  for (let first = 0x1f1e6; first <= 0x1f1ff; first += 1) {
    for (let second = 0x1f1e6; second <= 0x1f1ff; second += 1) {
      groups.Flags.push(String.fromCodePoint(first, second));
    }
  }
  groups.Symbols.push(...'0️⃣ 1️⃣ 2️⃣ 3️⃣ 4️⃣ 5️⃣ 6️⃣ 7️⃣ 8️⃣ 9️⃣ #️⃣ *️⃣'.split(' '));
  Object.keys(groups).forEach(label => { groups[label] = [...new Set(groups[label])]; });
  return groups;
};

export const BUILDER_EMOJI_GROUPS = createEmojiGroups();
export const COMMON_EMOJIS = [...new Set(Object.values(BUILDER_EMOJI_GROUPS).flat())];
